import PropTypes from 'prop-types';
import React from 'react';

import CSSTransitionOnMount from 'presentation/components/lib/CSSTransitionOnMount';
import CustomIcon from 'presentation/components/icons/CustomIcon';
import { ICON_TYPES } from 'enums/configuration';
import overrideStyles from 'lib/overrideStyle';

export default function AttachmentUploadButton(props) {
  AttachmentUploadButton.propTypes = {
    hasContent: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    onKeyDown: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
  };

  return (
    <CSSTransitionOnMount className="fadeAttachmentButtonIn" timeout={50}>
      <React.Fragment>
        {/* TODO: change multiple back to true when the smooch upload issue has been resolved. */}
        {/* Reference to accepted extensions from Smooch https://docs.smooch.io/guide/validating-files/#rejections */}
        <HiddenInput
          accept={AllowedFormats}
          type="file"
          id="gladlyFileInput"
          multiple={false}
          onChange={props.onChange}
        />
        <OuterWrapper
          aria-label="add attachment"
          data-aid="gladlyFileInputWrapper"
          hasContent={props.hasContent}
          tabIndex="0"
          role="button"
          onChange={props.onChange}
          onClick={handleOnClick}
          onKeyDown={handleKeyDown}
        >
          <InnerWrapper tabIndex="-1">
            <CustomIcon type={ICON_TYPES.ATTACHMENT_UPLOAD} />
          </InnerWrapper>
        </OuterWrapper>
      </React.Fragment>
    </CSSTransitionOnMount>
  );
}

function handleOnClick() {
  document.getElementById('gladlyFileInput').click();
}

function handleKeyDown(ev) {
  let charCode = ev.keyCode;
  let enterKey = 13;

  if (charCode === enterKey && !ev.shiftKey) {
    handleOnClick();
    ev.stopPropagation();
    ev.preventDefault();
    return false;
  }
}

const InnerWrapper = overrideStyles('div')`
  outline: none;
`;

const OuterWrapper = overrideStyles('div')`
  bottom: 15px;
  color: ${p => (p.hasContent ? p.theme.colors.submitArrow || p.theme.colors.brandPrimary : '#555555')};
  cursor: pointer;
  flex: 0 0 22px;
  height: 19px;
  order: 2;
  margin: 0px 10px 7px 5px;
  padding: 2px 2px 1px 2px;
  position: absolute;
  right: 2px;
  fill: #555555;
  transition: all ease 0.2s;
  width: 22px;

  transition: transform 0.5s;
  ${p => (p.hasContent ? 'transform: translate(-40px);' : null)}
`;

const HiddenInput = overrideStyles('input')`
  display: none;
  height: 0px;
  width: 0px;
`;

// 'image/svg+xml` is intentially excluded, there can contain script and could be evaluated when
// Firefox view image (XSS vunrebility)
const ImageFormats = ['image/gif', 'image/jpeg', 'image/png', 'image/tiff', 'image/webp'];

const AudioFormats = ['audio/aac', 'audio/amr', 'audio/m4a', 'audio/mpeg', 'audio/ogg', 'audio/wav', 'audio/x-aac'];

const VideoFormats = [
  'video/3gpp',
  'video/3gpp2',
  'video/quicktime',
  'video/mp4',
  'video/mpeg',
  'video/ogg',
  'video/webm',
  'video/x-m4v',
  'video/x-ms-wmv',
  'video/x-msvideo',
];

const TextFormat = ['text/calendar', 'text/csv', 'text/plain', 'text/yaml'];

const MiscFormat = ['message/rfc822', '.pps', '.ppsx', '.vcf'];

const ApplicationFormat = [
  'application/msword, application/vnd.apple.keynote',
  'application/ogg',
  'application/pdf',
  'application/vnd.apple.numbers',
  'application/vnd.ms-excel',
  'application/vnd.ms-powerpoint',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/x-7z-compressed',
  'application/x-iwork-pages-sffpages',
];

const AllowedFormats = []
  .concat(TextFormat, VideoFormats, AudioFormats, MiscFormat, ApplicationFormat, ImageFormats)
  .join(',');
